import { isBefore } from 'date-fns';
import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { useResolve } from '../../Container';
import { PreferencesModel } from '../../preferences/PreferencesModel';

export const isItXmas = () => isBefore(new Date(), new Date('2025-01-06'));

const WhenNotScrooge: LFC = ({ children }) => {
    const { scrooge2024: scrooge } = useObserver(useResolve(PreferencesModel));
    return scrooge ? null : <>{children}</>;
};

export const withXmas = <P extends unknown>(Component: React.ComponentType<P>) =>
    (props: P) => {
        return !!isItXmas() && <WhenNotScrooge>
            <Component {...(props as any)} />
        </WhenNotScrooge>;
    };
